<template>
  <v-card>
    <!-- Machine title -->
    <div class="bg-secondary text-center">
      <p class="text-uppercase text-h6">{{ title }}</p>
    </div>
    <div class="example">
      <v-row v-if="treeFilter" class="pr-2 pl-4 d-flex" justify="start"
        ><v-col class="pt-0 mt-0 pb-6 " cols="6">
          <TreeSelect
            :label="treeFilterName"
            :items="treeItems"
            @update:treeSelectedItems="onTreeSelection"/></v-col
      ></v-row>

      <apexchart
        :key="categoriesKey"
        type="bar"
        :width="'100%'"
        :height="'100%'"
        :series="series"
        :options="chartOptions"
      />
    </div>
    <v-card-actions class="font-weight-bold">
      {{ $t("common.total") }}: {{ totalValue }}
      {{ this.labels.totalValue }}
    </v-card-actions>
  </v-card>
</template>
<script>
import VueApexCharts from "vue3-apexcharts"
import colors from "vuetify/lib/util/colors"
import TreeSelect from "@/components/filters/TreeSelect"

export default {
  name: "Bar",
  props: {
    title: String,
    metricsData: Object,
    labels: Object,
    treeFilterName: String,
    treeItems: Array,
    treeFilter: Boolean
  },
  emits: ["treeSelectionChanged"],
  components: {
    apexchart: VueApexCharts,
    TreeSelect
  },
  computed: {
    // Remount on category change instead of letting ApexCharts animate bars on change
    // can crash without remount (corrupted path mid-transition).

    categoriesKey() {
      return (this.metricsData.labels || []).join(",")
    },
    series() {
      return [{ name: this.labels.yaxis, data: this.metricsData.dataSet }]
    },
    totalValue() {
      let total = 0
      this.metricsData.dataSet.forEach(dataSet => {
        total = total + dataSet
      })
      return total
    },
    chartOptions() {
      return {
        chart: {
          toolbar: {
            export: {
              csv: { filename: this.title },
              svg: { filename: this.title },
              png: { filename: this.title }
            }
          }
        },
        plotOptions: {
          bar: {
            distributed: true,
            columnWidth: "30"
          }
        },
        noData: {
          text: this.$t("$vuetify.noDataText"),
          style: {
            fontFamily: "Roboto, sans-serif"
          }
        },
        // Up to martin if I should hide or show these options
        // chart: {
        //   toolbar: {
        //     tools: {
        //       download: false // hides the download option
        //     }
        //   }
        // },
        // To hide or show value on the actual bar
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: this.metricsData.labels
        },
        yaxis: {
          title: {
            text: this.labels.yaxis
          }
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val
            }
          }
        },
        // Hide additional x-axis labels
        legend: {
          show: false
        },
        colors: [
          colors.orange.darken1,
          colors.green.lighten2,
          colors.blueGrey.darken3,
          colors.amber.lighten2
        ]
      }
    }
  },
  methods: {
    onTreeSelection(selectedItems) {
      this.$emit("treeSelectionChanged", selectedItems) // Emit again to ParentView
    }
  }
}
</script>
